"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItemProductToJSON = exports.CartItemProductFromJSONTyped = exports.CartItemProductFromJSON = exports.instanceOfCartItemProduct = void 0;
var runtime_1 = require("../runtime");
var CartItemVariation_1 = require("./CartItemVariation");
/**
 * Check if a given object implements the CartItemProduct interface.
 */
function instanceOfCartItemProduct(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCartItemProduct = instanceOfCartItemProduct;
function CartItemProductFromJSON(json) {
    return CartItemProductFromJSONTyped(json, false);
}
exports.CartItemProductFromJSON = CartItemProductFromJSON;
function CartItemProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'number': !(0, runtime_1.exists)(json, 'number') ? undefined : json['number'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'brand': !(0, runtime_1.exists)(json, 'brand') ? undefined : json['brand'],
        'variations': !(0, runtime_1.exists)(json, 'variations') ? undefined : (json['variations'] === null ? null : json['variations'].map(CartItemVariation_1.CartItemVariationFromJSON)),
    };
}
exports.CartItemProductFromJSONTyped = CartItemProductFromJSONTyped;
function CartItemProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}
exports.CartItemProductToJSON = CartItemProductToJSON;
